import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35921fdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-bold text-2xl" }, [
  /*#__PURE__*/_createTextVNode(" Välj "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-blue-500" }, "Specialisering")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center space-y-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pl-2" }, "Specialisering", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pl-2" }, "Specialisering", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_programDropdown = _resolveComponent("programDropdown")!
  const _component_specDropdown = _resolveComponent("specDropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["mb-2 border-2 p-2 rounded-md", {
      'opacity-50': _ctx.specFullyInitilized,
      'pointer-events-none': _ctx.specFullyInitilized,
    }])
    }, [
      _hoisted_1,
      _createVNode(_component_programDropdown, {
        dropDownData: _ctx.programs,
        selectedProgram: _ctx.selectedProgram,
        isDisabled: _ctx.specFullyInitilized
      }, null, 8, ["dropDownData", "selectedProgram", "isDisabled"]),
      _createVNode(_component_specDropdown, {
        dropDownData: _ctx.specs,
        selectedSpec: _ctx.selectedSpec,
        isDisabled: _ctx.specFullyInitilized
      }, null, 8, ["dropDownData", "selectedSpec", "isDisabled"])
    ], 2),
    (_ctx.specFullyInitilized)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn-submit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editSpec()))
          }, _hoisted_5),
          _createElementVNode("button", {
            class: "btn-submit",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.crateNewSpec()))
          }, _hoisted_8)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}